import { Container as e, HiddenTitle as t, Overlay as n } from "../styles.mjs";
import "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import * as a from "@radix-ui/react-dialog";
//#region src/components/FullscreenGallery/components/GalleryOverlay.tsx
var o = ({ open: o, onClose: s, title: c, onKeyDown: l, children: u }) => /* @__PURE__ */ r(a.Root, {
	open: o,
	onOpenChange: (e) => !e && s(),
	children: /* @__PURE__ */ i(a.Portal, { children: [/* @__PURE__ */ r(n, { "data-fullscreen-gallery": !0 }), /* @__PURE__ */ i(e, {
		"data-fullscreen-gallery": !0,
		"aria-describedby": void 0,
		onKeyDown: l,
		children: [/* @__PURE__ */ r(t, { children: c }), u]
	})] })
});
//#endregion
export { o as GalleryOverlay };
